(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnk-fam"] && !Shopify.designMode) return;
  try {
    
  /* Tanka Fam rail | Author: Abdullah | https://abdullahofficial.com */
  if (!customElements.get('tnk-fam-rail')) {
    class TnkFamRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tnk-fam__track');
        this.prev = this.querySelector('.tnk-fam__prev');
        this.next = this.querySelector('.tnk-fam__next');
        this.bar = this.querySelector('.tnk-fam__progress');
        if (!this.track) return;
        this.update = this.update.bind(this);
        if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
        if (this.next) this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          const t = this.track;
          t.scrollTo({ left: e.target.offsetLeft - t.offsetLeft - parseFloat(getComputedStyle(t).paddingLeft || 0), behavior: 'smooth' });
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      move(dir) {
        const t = this.track;
        const item = t.querySelector('.tnk-fam__item');
        const gap = parseFloat(getComputedStyle(t).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : t.clientWidth;
        const perView = Math.max(1, Math.floor((t.clientWidth + gap + 1) / step));
        t.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const scrollable = max > 2;
        this.classList.toggle('is-static', !scrollable);
        if (this.prev && this.next) {
          this.prev.disabled = !scrollable || t.scrollLeft <= 2;
          this.next.disabled = !scrollable || t.scrollLeft >= max - 2;
        }
        if (this.bar) {
          const pct = scrollable ? ((t.scrollLeft + t.clientWidth) / t.scrollWidth) * 100 : 100;
          this.bar.style.setProperty('--tnk-progress', pct.toFixed(1) + '%');
        }
      }
    }
    customElements.define('tnk-fam-rail', TnkFamRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnk-footer"] && !Shopify.designMode) return;
  try {
    
  /* Tanka Footer: accordions closed on mobile, open on desktop | Author: Abdullah | https://abdullahofficial.com */
  (() => {
    const mq = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      document.querySelectorAll('.tnk-footer__col').forEach((col) => {
        if (mq.matches) {
          if (!col.dataset.tnkTouched) col.open = false;
        } else {
          col.open = true;
        }
      });
    };
    document.addEventListener('click', (e) => {
      const head = e.target.closest('.tnk-footer__col-head');
      if (!head) return;
      if (!mq.matches) { e.preventDefault(); return; }
      head.parentElement.dataset.tnkTouched = '1';
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnk-hero"] && !Shopify.designMode) return;
  try {
    
  /* Tanka Hero Slider | Author: Abdullah | https://abdullahofficial.com */
  if (!customElements.get('tnk-hero-slider')) {
    class TnkHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.tnk-hero__slide'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('.tnk-hero__dot'));
        this.index = 0;
        this.timer = null;
        this.paused = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const prev = this.querySelector('.tnk-hero__prev');
        const next = this.querySelector('.tnk-hero__next');
        if (prev) prev.addEventListener('click', () => this.nav(this.index - 1));
        if (next) next.addEventListener('click', () => this.nav(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.nav(i)));

        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.nav(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        }, { passive: true });

        this.addEventListener('mouseenter', () => { this.paused = true; this.stop(); });
        this.addEventListener('mouseleave', () => { this.paused = false; this.start(); });
        this.addEventListener('focusin', () => { this.paused = true; this.stop(); });
        this.addEventListener('focusout', () => { this.paused = false; this.start(); });

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.paused = true; this.stop(); this.go(i); }
        };
        this.onBlockDeselect = (e) => {
          if (!this.contains(e.target)) return;
          this.paused = false;
          this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(i) {
        const n = this.slides.length;
        i = ((i % n) + n) % n;
        if (i === this.index) return;

        const current = this.slides[this.index];
        const target = this.slides[i];

        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        current.inert = true;

        target.classList.add('is-active');
        target.removeAttribute('aria-hidden');
        target.inert = false;

        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === i);
          dot.setAttribute('aria-current', k === i ? 'true' : 'false');
        });

        this.index = i;
      }

      nav(i) {
        this.go(i);
        this.stop();
        this.start();
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.reduced || this.paused || this.timer) return;
        const speed = parseInt(this.dataset.speed, 10) || 6000;
        this.timer = setInterval(() => this.go(this.index + 1), speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('tnk-hero-slider', TnkHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnk-page"] && !Shopify.designMode) return;
  try {
    
  /* Tanka Page: wrap tables + FAQ accordion | Author: Abdullah | https://abdullahofficial.com */
  (() => {
    const wrapTables = (root) => {
      root.querySelectorAll('.tnk-page__rte table').forEach((t) => {
        if (t.parentElement.classList.contains('tnk-page__table-wrap')) return;
        const w = document.createElement('div');
        w.className = 'tnk-page__table-wrap';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
      });
    };

    const run = () => wrapTables(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);

    if (customElements.get('tnk-faq')) return;
    class TnkFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        const nodes = Array.from(this.childNodes);
        const frag = document.createDocumentFragment();
        let item = null;
        let answer = null;

        nodes.forEach((n) => {
          if (n.nodeType === 1 && n.tagName === 'H3') {
            item = document.createElement('details');
            item.className = 'tnk-faq__item';
            const q = document.createElement('summary');
            q.className = 'tnk-faq__q';
            const label = document.createElement('span');
            label.innerHTML = n.innerHTML;
            const icon = document.createElement('span');
            icon.className = 'tnk-faq__icon';
            icon.setAttribute('aria-hidden', 'true');
            q.append(label, icon);
            answer = document.createElement('div');
            answer.className = 'tnk-faq__a';
            item.append(q, answer);
            frag.appendChild(item);
          } else if (answer) {
            answer.appendChild(n);
          } else {
            frag.appendChild(n);
          }
        });

        this.textContent = '';
        this.appendChild(frag);
      }
    }
    customElements.define('tnk-faq', TnkFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnk-site-extras"] && !Shopify.designMode) return;
  try {
    
  /* Tanka Site Extras | Author: Abdullah | https://abdullahofficial.com */
  if (!customElements.get('tnk-site-extras')) {
    class TnkSiteExtras extends HTMLElement {
      connectedCallback() {
        this.initHeader();
        this.initSearch();
        this.initTop();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.mo) this.mo.disconnect();
        document.documentElement.classList.remove('tnk-hdr', 'tnk-hdr--line', 'tnk-hdr--shadow');
      }

      /* 1. Header */
      initHeader() {
        const mode = this.dataset.header;
        const root = document.documentElement;
        if (mode === 'off') return;
        const isHome = this.dataset.home === 'true';
        root.classList.add('tnk-hdr');
        if (!isHome || mode === 'always') root.classList.add('tnk-hdr--line');

        this.onScroll = () => {
          const scrolled = window.scrollY > 8;
          const shadow = mode === 'always' || (mode === 'inner' && !isHome) || scrolled;
          root.classList.toggle('tnk-hdr--shadow', shadow);
          if (isHome && mode !== 'always') root.classList.toggle('tnk-hdr--line', scrolled);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      /* 2. Search */
      initSearch() {
        const tpl = this.querySelector('.tnk-extras__search-tpl');
        if (!tpl) return;

        const attach = () => {
          const wrapper = document.querySelector('.predictive-search-form__content-wrapper');
          const input = document.querySelector('.predictive-search-form input[type="search"], .predictive-search-form .search-input');
          if (!wrapper || !input) return false;
          if (this.dataset.placeholder) input.setAttribute('placeholder', this.dataset.placeholder);
          if (wrapper.querySelector('.tnk-search-help')) return true;

          const help = tpl.content.firstElementChild.cloneNode(true);
          wrapper.prepend(help);

          const sync = () => { help.hidden = input.value.trim().length > 0; };
          input.addEventListener('input', sync);
          const reset = document.querySelector('.predictive-search__reset-button');
          if (reset) reset.addEventListener('click', () => setTimeout(sync, 0));
          sync();
          return true;
        };

        if (attach()) return;
        this.mo = new MutationObserver(() => { if (attach()) this.mo.disconnect(); });
        this.mo.observe(document.body, { childList: true, subtree: true });
      }

      /* 4. Back to top */
      initTop() {
        const btn = document.querySelector('.tnk-to-top');
        if (!btn) return;
        const update = () => btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.2);
        window.addEventListener('scroll', update, { passive: true });
        btn.addEventListener('click', () => {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        });
        update();
      }
    }
    customElements.define('tnk-site-extras', TnkSiteExtras);
  }

  } catch(e) { console.error(e); }
})();
})();
